import * as angular from 'angular';
import { tagDefaultState, calculatedDefaultState } from '../../common/constants';
import { Identifier } from '../../models';
import { IdentifierType } from '../../models/enum';
import { SeriesSelectorViewModel } from '../../models/viewModels/SeriesSelectorViewModel';
import { IGroupService } from '../data';

export interface IStateRedirectService {
    redirectIdentifier(identifier: Identifier): angular.IPromise<any>;
    redirectIdentifierFromModel(model: SeriesSelectorViewModel): angular.IPromise<any>;
    getStateUrl(identifier: Identifier): string;
}

interface State {
    name: string;
    params: any;
}

export class StateRedirectService implements IStateRedirectService {
    static serviceId = 'stateRedirectService';
    static $inject = ['$state', 'groupService'];
    constructor(
        private _$state: angular.ui.IStateService,
        private _groupService: IGroupService
    ) {

    }

    redirectIdentifier(identifier: Identifier): angular.IPromise<any> {
        const s = this.getState(identifier);
        const ret = this._$state.go(s.name, s.params);
        return ret;
    }

    getStateUrl(identifier: Identifier): string {
        const s = this.getState(identifier);
        return this._$state.href(s.name, s.params);
    }

    private getState(identifier: Identifier): State {
        const result: State = {
            name: 'notFound',
            params: {}
        };
        switch (identifier.type) {
            case IdentifierType.Tag:
                result.name = tagDefaultState;
                result.params = { tagDefinitionGuid: identifier.tagDefinitionGuid };
                break;
            case IdentifierType.CalculatedValue:
                result.name = calculatedDefaultState;
                result.params = { identifierGuid: identifier.guid };
                break;
            case IdentifierType.Linked:
                result.name = 'linked';
                result.params = {
                    linkedGuid: identifier.linkedGuid
                };

                break;
        }
        return result;
    }

    redirectIdentifierFromModel(model: SeriesSelectorViewModel): angular.IPromise<any> {
        const id = ({
            type: model.identifierType,
            tagDefinitionGuid: model.tagDefinitionGuid,
            guid: model.identifierType,
            linkedGuid: model.linkedGuid
        }) as any;
        return this.redirectIdentifier(id);
    }

}

